<mat-form-field appearance="outline">
  <mat-label>Производитель</mat-label>
  <input matInput [formControl]="control" [matAutocomplete]="auto" />
  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="displayProperty"
    (optionSelected)="handleSelect($event)"
  >
    <mat-option *ngFor="let brand of filteredOptions | async" [value]="brand">
      {{ brand.description }}
    </mat-option>
    <mat-option *ngIf="(filteredOptions | async)?.length === 0" [value]="control.value">
      Создать {{ control.value }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
